import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/**
 * Polls a condition until it returns true or times out
 * @param condition Function that returns boolean to check
 * @param timeout Maximum time to wait for condition to be met
 * @param options Configuration options
 * @returns Promise that resolves to true if condition is met, false if timeout occurs
 */
export var waitFor = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(condition) {
    var timeout,
      _ref2,
      _ref2$interval,
      interval,
      _ref2$throwOnTimeout,
      throwOnTimeout,
      startTime,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          timeout = _args.length > 1 && _args[1] !== undefined ? _args[1] : 10000;
          _ref2 = _args.length > 2 && _args[2] !== undefined ? _args[2] : {}, _ref2$interval = _ref2.interval, interval = _ref2$interval === void 0 ? 500 : _ref2$interval, _ref2$throwOnTimeout = _ref2.throwOnTimeout, throwOnTimeout = _ref2$throwOnTimeout === void 0 ? false : _ref2$throwOnTimeout;
          startTime = Date.now();
        case 3:
          if (!(Date.now() - startTime < timeout)) {
            _context.next = 10;
            break;
          }
          if (!condition()) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return", true);
        case 6:
          _context.next = 8;
          return new Promise(function (resolve) {
            return setTimeout(resolve, interval);
          });
        case 8:
          _context.next = 3;
          break;
        case 10:
          if (!throwOnTimeout) {
            _context.next = 12;
            break;
          }
          throw new Error("waitFor failed after ".concat(timeout, "ms"));
        case 12:
          return _context.abrupt("return", false);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function waitFor(_x) {
    return _ref.apply(this, arguments);
  };
}();


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/utils/dist/esm/waitFor.js
// module id = 2616
// module chunks = 11